// extracted by mini-css-extract-plugin
module.exports = {"heading":"DMCAPrivacyPolicyPage_heading__3vSg3","content":"DMCAPrivacyPolicyPage_content__3iy9K"};